var map = {
	"./PragmaticaSlabLight/PragmaticaSlabLight": 348,
	"./PragmaticaSlabLight/PragmaticaSlabLight.eot": 680,
	"./PragmaticaSlabLight/PragmaticaSlabLight.otf": 681,
	"./PragmaticaSlabLight/PragmaticaSlabLight.svg": 348,
	"./PragmaticaSlabLight/PragmaticaSlabLight.ttf": 682,
	"./PragmaticaSlabLight/PragmaticaSlabLight.woff": 683,
	"./QanelasBold/QanelasBold": 349,
	"./QanelasBold/QanelasBold.eot": 684,
	"./QanelasBold/QanelasBold.otf": 685,
	"./QanelasBold/QanelasBold.svg": 349,
	"./QanelasBold/QanelasBold.ttf": 686,
	"./QanelasBold/QanelasBold.woff": 687,
	"./QanelasLight/QanelasLight": 350,
	"./QanelasLight/QanelasLight.eot": 688,
	"./QanelasLight/QanelasLight.svg": 350,
	"./QanelasLight/QanelasLight.ttf": 689,
	"./QanelasLight/QanelasLight.woff": 690,
	"./QanelasLight/QanelasLight.woff2": 691,
	"./QanelasMedium/QanelasMedium": 351,
	"./QanelasMedium/QanelasMedium.eot": 692,
	"./QanelasMedium/QanelasMedium.svg": 351,
	"./QanelasMedium/QanelasMedium.ttf": 693,
	"./QanelasMedium/QanelasMedium.woff": 694,
	"./QanelasMedium/QanelasMedium.woff2": 695,
	"./QanelasRegular/QanelasRegular": 352,
	"./QanelasRegular/QanelasRegular.eot": 696,
	"./QanelasRegular/QanelasRegular.svg": 352,
	"./QanelasRegular/QanelasRegular.ttf": 697,
	"./QanelasRegular/QanelasRegular.woff": 698,
	"./QanelasSemiBold/QanelasSemiBold": 353,
	"./QanelasSemiBold/QanelasSemiBold.eot": 699,
	"./QanelasSemiBold/QanelasSemiBold.svg": 353,
	"./QanelasSemiBold/QanelasSemiBold.ttf": 700,
	"./QanelasSemiBold/QanelasSemiBold.woff": 701,
	"./QanelasThin/QanelasThin": 354,
	"./QanelasThin/QanelasThin.eot": 702,
	"./QanelasThin/QanelasThin.otf": 703,
	"./QanelasThin/QanelasThin.svg": 354,
	"./QanelasThin/QanelasThin.ttf": 704,
	"./QanelasThin/QanelasThin.woff": 705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 679;